// src/components/minicomponents/Loader.js

import React from "react";
import "./Loader.css"; // We will create this CSS file next

const Loader = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default Loader;
